import React from 'react';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import API from "../../Services/BaseService";
import { useHistory, useLocation, useParams } from "react-router-dom";
import CommonPopup from '../../Component/CommonPopup/CommonPopup';
import checkImg from '../../assets/img/check.svg';
import errorImg from '../../assets/img/erroricon.png';
import "../../Component/CommonPopup/commonPopup.css";
// import wsBaseURL from '../../Services/Constant';
// import { w3cwebsocket as W3CWebSocket } from "websocket";


// const ws=new WebSocket(wsBaseURL);
// const contentDefaultMessage = "Start writing your document here";

import PageNotFound from '../FallBackUI/PageNotFound';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
const Accept = (props) => {
  console.log("checking the props value", props)
  const history = useHistory();
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  // const { id } = useParams();
  const sellerData = useSelector(state => state.LoginReducer.payload);

  const [isCommonPopupOpen, setIsCommonPopupOpen] = useState(false);
  const [popupTitle, setPopupTitle] = useState("");
  const [popupMsg, setPopupMsg] = useState("");
  const [popupType, setPopupType] = useState("");
  const [popupActionType, setPopupActionType] = useState("");
  const [popupActionValue, setPopupActionValue] = useState("");
  const [popupActionPath, setPopupActionPath] = useState("");
  // const [userNameError,setUsernameError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [alertmessage, setAlertMessage] = useState("");
  const [alerttitle, setAlertTitle] = useState("");
  const [alertimg, setAlertImg] = useState("");
  const email = sellerData.email;

  const [errors, setErrors] = useState("");
  const [errorFlag, setErrorFlag] = useState(false);

  const [toggleAcceptPopupOpen, setToggleAcceptPopupOpen] = useState(true);
  const toggleCommonPopup = () => {
    setIsCommonPopupOpen(!isCommonPopupOpen);
  }

  // const handleAccepts=()=>{

  //   setPasswordError("")

  //   ws.send(JSON.stringify({
  //           seller_dealer_id:sellerData.seller_dealer_id, 
  //           seller_id:sellerData.seller_id, 
  //           active: 1,
  //           car_id:props.carId, 
  //           buyer_dealer_id:props.buyerId, 
  //           updatedBy:sellerData.seller_id,
  //           createdBy:sellerData.seller_id,
  //           status: "sold",
  //           price:props.highBid,
  //           buying_proccess:"seller",
  //           model:"selleraccept"
  //     }))


  //       ws.onmessage = (message) => {
  // 			  console.log("check the message accept page===",message.data)
  // 			  const dataFromServer = JSON.parse(message.data)
  // 			  console.log("check the  data FromServer", dataFromServer)


  //     if (dataFromServer[1] == "selleraccept" && dataFromServer[2]?.success) {

  //       setToggleAcceptPopupOpen(false);
  //        setAlertImg(checkImg);
  //        setAlertTitle("Successfully Accepted")
  //        setAlertMessage("Thank you so much for your business, We thank you to let us earn your business.")

  //   } 
  //   // else {
  //   //     setToggleAcceptPopupOpen(false);
  //   //     setAlertImg(errorImg);
  //   //     setAlertMessage("Network issue")

  //   // }

  //     }
  // }

  const handleAccepts = async () => {
    //setUsernameError("")
    setPasswordError("")

    //  if(!userName){
    //   setUsernameError("Username is required")
    //   return;
    //  }
    // else if(userName && !new RegExp(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i).test(userName)){
    //   setUsernameError("Must match the email format")
    // return;
    //   }
    //   if(!password){
    //     setPasswordError("Password is required")
    //     return;
    //   }
    //   else if(password && !new RegExp(/(^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,}))/).test(password)){
    //     setPasswordError("Password must have minimum of 8 characters with the combination of upper ,lower case letters , number and a special character")
    //     return;
    // }


    let request = {
      seller_dealer_id: sellerData.seller_dealer_id,
      seller_id: sellerData.seller_id,
      active: 1,
      car_id: props.carId,
      // email:userName,
      // email:sellerData.email,
      //  password:password,
      buyer_dealer_id: props.buyDealerId,
      buyer_id: props.buyerId,
      updatedBy: sellerData.seller_id,
      createdBy: sellerData.seller_id,
      status: "sold",
      price: props.highBid,
      buying_proccess: "seller",
      seller_token: sellerData.seller_token,
      transportation_charge: props.transportationCharge,
      type: ""
    }
    console.log("Save Search Request : ", request);
    // return
    await API.post("carbuy/update", request).then(response => {

      console.log("saveeeeee", response)
      if (response.data.success) {
        setToggleAcceptPopupOpen(false);
        setAlertImg(checkImg);
        setAlertTitle("Successfully Accepted")
        setAlertMessage("Thank you so much for your business, We thank you to let us earn your business.")

      } else {
        const { data } = response;
        setToggleAcceptPopupOpen(false);
        setAlertImg(errorImg);
        setAlertMessage(data.error.err)
      }

    }).catch(function (error) {
      if (error.response) {
        setErrors(error.response.data.error)
        setErrorFlag(true)
      }
    });
  }

  const handleClose = () => {
    props.toggle()
    redirectSoldpage(props.carId, sellerData.seller_dealer_id)
    // props.handleCounterRedirect()
  }
  const redirectSoldpage = (pathid, seller_dealer_id) => {
    history.push({
      pathname: "/soldcardetails",
      state: { backURL: "/carlist", id: pathid, sellerDealerId: seller_dealer_id }
    });
  };
  return (

    <div>

      {errorFlag === true ? <PageNotFound error={errors} /> :
        <>

          {toggleAcceptPopupOpen ?
            (

              <Modal show={true} onHide={props.toggle} centered >
                <Modal.Header className='Terms-login'>
                  <h2 > Accept confirmation </h2>
                </Modal.Header>
                <Modal.Body>

                <p className="deletemsg">
                    Are you sure wants to accept please confirm
                  </p>
                  <div class="inactivebtns">
                    <button className="cta-btns" onClick={props.toggle}>Cancel</button>    <button className="cta-btns" onClick={handleAccepts}>Accept</button>
                  </div>
                </Modal.Body>
              </Modal>) :
            (

              <Modal show={true} onHide={props.toggle} centered>
                <Modal.Header className='Terms-login'>
                  <h2 >{alerttitle}</h2>
                </Modal.Header>
                <Modal.Body>
                  <div className="Commonfull-icon">
                    <img alt="" className={alertimg === checkImg ? "successImg " : "errorImg"} src={alertimg}></img>
                  </div>
                  <div class="">
                    <p class="text-center">{alertmessage}</p>
                  </div>
                </Modal.Body>
                <div class="inactivebtns">
                  <button className="cta-btns" onClick={handleClose}>ok</button>
                </div>
              </Modal>
            )}
        </>
      }


      {isCommonPopupOpen && <CommonPopup
        handleClose={isCommonPopupOpen}
        popupTitle={popupTitle}
        popupMsg={popupMsg}
        popupType={popupType}
        popupActionType={popupActionType}
        popupActionValue={popupActionValue}
        popupActionPath={popupActionPath}
      />}
    </div >
  )
}

export default Accept;